/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntityPrivacySignalsOrderBy } from './MonitEntityPrivacySignalsOrderBy';
import {
    MonitEntityPrivacySignalsOrderByFromJSON,
    MonitEntityPrivacySignalsOrderByFromJSONTyped,
    MonitEntityPrivacySignalsOrderByToJSON,
} from './MonitEntityPrivacySignalsOrderBy';

/**
 * 
 * @export
 * @interface MonitGetEntityPrivacySignalsQueries
 */
export interface MonitGetEntityPrivacySignalsQueries {
    /**
     * 
     * @type {number}
     * @memberof MonitGetEntityPrivacySignalsQueries
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitGetEntityPrivacySignalsQueries
     */
    page_size?: number;
    /**
     * 
     * @type {MonitEntityPrivacySignalsOrderBy}
     * @memberof MonitGetEntityPrivacySignalsQueries
     */
    order_by?: MonitEntityPrivacySignalsOrderBy;
    /**
     * 
     * @type {boolean}
     * @memberof MonitGetEntityPrivacySignalsQueries
     */
    desc?: boolean;
}

/**
 * Check if a given object implements the MonitGetEntityPrivacySignalsQueries interface.
 */
export function instanceOfMonitGetEntityPrivacySignalsQueries(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitGetEntityPrivacySignalsQueriesFromJSON(json: any): MonitGetEntityPrivacySignalsQueries {
    return MonitGetEntityPrivacySignalsQueriesFromJSONTyped(json, false);
}

export function MonitGetEntityPrivacySignalsQueriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitGetEntityPrivacySignalsQueries {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'order_by': !exists(json, 'order_by') ? undefined : MonitEntityPrivacySignalsOrderByFromJSON(json['order_by']),
        'desc': !exists(json, 'desc') ? undefined : json['desc'],
    };
}

export function MonitGetEntityPrivacySignalsQueriesToJSON(value?: MonitGetEntityPrivacySignalsQueries | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'order_by': MonitEntityPrivacySignalsOrderByToJSON(value.order_by),
        'desc': value.desc,
    };
}

